import useSourceStore from "./SourceStore.js";

import RiveArtboard from "../ComponentsWrappers/RiveArtboard.jsx";

import useApplicationSettings from "./ApplicationSettings.js";

let downloads = [];

export function addInDownloadsStorage(func, key) {
  if (!downloads.some((element) => element.key == key)) {
    let fileWrapper = {
      key: key,
      loaded: false,
      func: func,
    };
    const { setContentToLoad } = useApplicationSettings.getState();
    setContentToLoad();
    fileWrapper.func(allLoadedCheck);
    downloads.push(fileWrapper);
  }
}

export function downloadWrapper(file, fileSetter) {
  return function (next) {
    fetch(file)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        const fileURL = URL.createObjectURL(blob);
        fileSetter(fileURL);
        this.loaded = true;
        const { setLoadedContent } = useApplicationSettings.getState();
        setLoadedContent();
        next();
      })
      .catch((error) => {
        if (file.includes(baseUrl)) {
          const localPath = file.replace(baseUrl, "");
          return fetch(localPath)
            .then((response) => response.blob())
            .then((blob) => {
              const fileURL = URL.createObjectURL(blob);
              fileSetter(fileURL);
              this.loaded = true;
              const { setLoadedContent } = useApplicationSettings.getState();
              setLoadedContent();
              next();
            });
        }
      });
  };
}

function allLoadedCheck() {
  if (downloads.every((element) => element.loaded == true)) {
    const { setAllLoaded } = useSourceStore.getState();

    setTimeout(() => {
      setAllLoaded(true);
    }, 200);

    // const {setHistory} = useSourceStore.getState()
    // setHistory(() => {RiveArtboard({artboard: 'history' , stateMachines:'State Machine 1', setLoading: true})})
  }
}
